/* @flow */

import { compose } from 'ramda';
import * as React from 'react';

import useNotificationPortal from './hook/useNotificationPortal';
import useMounted from 'src/shared/app/base/hook/useMounted';
import NotificationContainerDumb from 'src/shared/app/notification/component/NotificationContainerDumb';

const NotificationPortal = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const isMounted = useMounted();
  const { queue } = useNotificationPortal();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  if (isMounted) {
    return (
      <NotificationContainerDumb queue={queue}></NotificationContainerDumb>
    );
  }

  return null;
};

export default compose(React.memo)(NotificationPortal);
